// extracted by mini-css-extract-plugin
module.exports = {"wrapperInner":"style_wrapperInner_6JeZC","goToRight":"style_goToRight_oEx9I","goNextPage":"style_goNextPage_1dDcO"};